import type { IconData } from '@stacksjs/iconify-core'

export const devicesTablet: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15 14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2zm-7 .25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesTablet
